import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../assets/audioGuide/location.png';
import _imports_1 from '../assets/audioGuide/r_location.png';
const _hoisted_1 = {
  class: "audio-box"
};
const _hoisted_2 = {
  class: "audio"
};
const _hoisted_3 = {
  class: "img-cover"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "audio-desc"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "audio-menu"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0,
  class: "location",
  src: _imports_0
};
const _hoisted_11 = {
  key: 1,
  class: "location",
  src: _imports_1
};
const _hoisted_12 = {
  class: "number"
};
const _hoisted_13 = ["innerHTML"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 0,
  ref: "audioItem"
};
const _hoisted_17 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`audioItem ${_ctx.$route.query.fid == 152288 ? 'nxbwgAudioItem' : ''}`)
  }, [_createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.audioList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
      class: "img-box",
      onClick: $event => $options.getAudioDetail(item)
    }, [_createElementVNode("img", {
      class: "audio-img",
      src: item.littleImage
    }, null, 8, _hoisted_5)], 8, _hoisted_4)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
      onClick: $event => $options.getAudioDetail(item),
      class: "audio-name"
    }, [_createElementVNode("div", null, _toDisplayString($props.language ? item.en_antiqueName : item.antiqueName), 1)], 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
      class: "audio-location",
      onClick: $event => $options.getAudioDetail(item)
    }, [_ctx.$route.query.fid != 152288 ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : (_openBlock(), _createElementBlock("img", _hoisted_11)), _createElementVNode("span", _hoisted_12, _toDisplayString(item.exhibitionLocation), 1)], 8, _hoisted_9), _createElementVNode("div", {
      class: "duration",
      innerHTML: $props.language ? item.en_description : item.description
    }, null, 8, _hoisted_13), item.audioPath ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      onClick: $event => $options.clickPlay(index, item),
      class: "play"
    }, [_createElementVNode("img", {
      class: "progress_bg play-icon",
      src: `${$data.isPlaying && $data.currentIndex === index ? require(`../assets/audioGuide/${_ctx.$route.query.fid != 152288 ? 'pause' : 'r_pause'}.png`) : require(`../assets/audioGuide/${_ctx.$route.query.fid != 152288 ? 'play' : 'r_play'}.png`)}`
    }, null, 8, _hoisted_15)], 8, _hoisted_14)) : _createCommentVNode("", true)])])]);
  }), 256))]), $data.audioPath ? (_openBlock(), _createElementBlock("audio", _hoisted_16, [_createElementVNode("source", {
    src: $data.audioPath,
    type: "audio/mpeg"
  }, null, 8, _hoisted_17)], 512)) : _createCommentVNode("", true)], 2);
}